import * as React from 'react';
import AccreditationExpiredComponent, { AccreditationExpiredComponentProps } from './AccreditationExpired.component';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import InvestorType from 'src/entities/InvestorType';
import {
  changeInvestorType,
  ChangeInvestorTypeAction
} from 'src/actions/investor-type/change-data/ChangeInvestorType.actions';
import {
  updateInvestorType,
  UpdateInvestorTypeAction,
  UpdateInvestorTypeSuccess
} from 'src/actions/investor-type/update/UpdateInvestorType.actions';
import * as updateInvestorTypeTypes from 'src/actions/investor-type/update/Types';
import InvestmentFormContainer from 'src/modules/modals/investment-funnel/InvestmentForm.container';
import { RootState } from 'src/reducers/RootReducer';
import { connect, Dispatch } from 'react-redux';
import { OpenModal, openModal } from 'src/actions/modal';
import User from 'src/entities/User';

interface StateProps {
  user?: User;
  investorType?: InvestorType;
}

interface DispatchProps {
  openModal: (content: JSX.Element) => void;

  changeInvestorType(investorType: InvestorType):
    ChangeInvestorTypeAction;

  updateInvestorType(physicalPersonId: number, investorType: InvestorType):
    Promise<UpdateInvestorTypeAction>;
}

interface OwnProps {
  modalRef?: Modal;
}

interface Props extends StateProps, DispatchProps, OwnProps {
}

class AccreditationExpiredContainer extends React.Component<Props> {

  public render(): React.ReactNode {
    return (this.props.user && this.props.investorType ?
      <AccreditationExpiredComponent {...this.getComponentProps()}/> : null);
  }

  private handleChange(value: string): void {
    const investorType = this.props.investorType!;
    investorType.confirmationMessage = value;
    this.props.changeInvestorType(new InvestorType(investorType));
  }

  private handleSubmit(): void {
    this.props.updateInvestorType(
      this.props.user!.physicalPersonId, this.props.investorType!)
      .then((response: UpdateInvestorTypeSuccess) => {
        if (response.type === updateInvestorTypeTypes.UPDATE_INVESTOR_TYPE_SUCCESS) {
          this.props.openModal(
            <InvestmentFormContainer/>
          );
        }
      });
  }

  private getComponentProps(): AccreditationExpiredComponentProps {
    return {
      investorType: this.props.investorType!,
      handleChange: (value: string) => this.handleChange(value),
      handleSubmit: () => this.handleSubmit(),
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  changeInvestorType: (investorType: InvestorType):
    ChangeInvestorTypeAction => (
    dispatch(changeInvestorType(investorType))
  ),
  updateInvestorType: (physicalPersonId: number, investorType: InvestorType):
    Promise<UpdateInvestorTypeAction> => (
    dispatch(updateInvestorType(physicalPersonId, investorType))
  ),
  openModal: (component: JSX.Element): OpenModal => (
    dispatch(openModal(component))
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  user: state.getUser.user,
  investorType: state.getInvestorType.investorType,
});

export default connect(mapStateToProps, mapDispatchToProps)(AccreditationExpiredContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/AccreditationExpired.container.tsx